import { render, staticRenderFns } from "./SortingBrads.vue?vue&type=template&id=0276054a&scoped=true&"
import script from "./SortingBrads.vue?vue&type=script&lang=js&"
export * from "./SortingBrads.vue?vue&type=script&lang=js&"
import style0 from "./SortingBrads.vue?vue&type=style&index=0&id=0276054a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0276054a",
  null
  
)

export default component.exports